import ReactStoreWebsite from "./assets/react-store-website.png";
import Kasper from "./assets/kasper.png";
import Leon from "./assets/leon.png";
import Blog from "./assets/blog_website_home.png";

const Data = [
  {
    id: 1,
    image: Blog,
    title: "Blog_website_with_MERN",
    github: "https://github.com/warda-hammad/blog_wibsite_with_MERN",
    demo: "https://blog-server-mqin.onrender.com/blogs",
    info: "This is my first website with a MERN Stack, which is a blog that you can create a new blog, delete or even view. The first page contains all the blogs you have created, and there is an About page where you can write things for people to know about you",
  },
  {
    id: 2,
    image: ReactStoreWebsite,
    title: "react-store-website",
    github: "https://github.com/warda-hammad/react-store-website",
    demo: "https://react-store-website.netlify.app",
    info: "store sells decorative items for your home. These items can include vases, figurines, showpieces, photo frames and more.",
  },
  {
    id: 3,
    image: Kasper,
    title: "kasper",
    github: "https://github.com/warda-hammad/kasper-template-two",
    demo: "https://warda-hammad.github.io/kasper-template-two",
    info: "template that shows your art",
  },
  {
    id: 4,
    image: Leon,
    title: "leon",
    github: "https://github.com/warda-hammad/template-one",
    demo: "https://warda-hammad.github.io/template-one/",
    info: "Leon template",
  },
];

export default Data;
